/**
 * @param {String} x
 * @return {String}
 */
const lowerCase = (x) => String.prototype.toLowerCase.call(x);

export { lowerCase };
